import ApiClient from './ApiClient';

export const getReservationChangeInfo = (token: string, companyCode: string) => ApiClient.getNoAuthV2(
  `/v1/onlineReservations/change/${token}?companyCode=${companyCode}`,
);

export const changeReservationDatetime = (token: string, companyCode: string, newDesiredTime: string) => ApiClient.putJsonData(
  `/v1/onlineReservations/change/${token}/datetime`,
  { companyCode },
  { newDesiredTime },
);

export const cancelReservation = (token: string, companyCode: string) => ApiClient.deleteBody(
  `/v1/onlineReservations/change/${token}?companyCode=${companyCode}`,
  {},
);

export const getChangeBookingCalendar = (token: string, companyCode: string, startDate: string, endDate: string, orgId?: string) => {
  const orgIdParam = orgId ? `&orgId=${orgId}` : '';
  return ApiClient.getNoAuthV2(
    `/v1/reservations/bookingOnline/change/${token}?companyCode=${companyCode}&startDate=${startDate}&endDate=${endDate}${orgIdParam}`,
  );
};

export const menuReselect = (
  token: string,
  companyCode: string,
  payload: { newContractCourseId: string; newOrgId: string; newDesiredTime: string },
) => ApiClient.putJsonData(
  `/v1/onlineReservations/change/${token}/menu`,
  { companyCode },
  payload,
);
